import { useSelector } from "react-redux";
import { utilsState } from "../../sotre/redux/features/utilsSlice";
import Select from "../../components/common/inputs/Select";

export default function UserFilter({ filterDataHandler }) {
  const { utils } = useSelector(utilsState);
  return (
    <div className="w-full flex flex-col flex-wrap my-8 gap-6 px-6">
      <div className="w-full flex flex-col sm:flex-row gap-6">
        <div className="w-full sm:w-4/12">
          <form class="max-w-md mx-auto">
            <label
              for="default-search"
              class="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
            >
              Search
            </label>
            <div class="relative">
              <div class="absolute inset-y-0 end-0 flex items-center pe-3 pointer-events-none">
                <svg
                  class="w-4 h-4 text-gray-500 dark:text-gray-400"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 20 20"
                >
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                  />
                </svg>
              </div>
              <input
                onChange={(e) =>
                  filterDataHandler({ page: 1, searchText: e.target.value })
                }
                type="search"
                className="bg-white text-center sm:text-right border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="جست و جو کاربر ..."
                required
              />
            </div>
          </form>
        </div>
        <div className="w-full sm:w-4/12">
          <form class="max-w-md mx-auto">
            <label
              for="default-search"
              class="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
            >
              Search
            </label>
            <div class="relative">
              <div class="absolute inset-y-0 end-0 flex items-center pe-3 pointer-events-none">
                <svg
                  class="w-4 h-4 text-gray-500 dark:text-gray-400"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 20 20"
                >
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                  />
                </svg>
              </div>
              <input
                onChange={(e) =>
                  filterDataHandler({ page: 1, refCode: e.target.value })
                }
                type="search"
                className="bg-white text-center sm:text-right border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="جست و جو بر اساس کد رفرال ..."
                required
              />
            </div>
          </form>
        </div>
        <div className="w-full sm:w-4/12">
          <Select
            onChange={(e) =>
              filterDataHandler({ page: 1, role: e.target.value })
            }
            id="province"
            useFormik={false}
            className="bg-white text-center sm:text-right"
          >
            <option value={""} selected>
              همه ی نقش ها
            </option>
            {utils
              ? utils.ROLES_VALUES.map((item) => {
                  return <option value={item.value}>{item?.name}</option>;
                })
              : null}
          </Select>
        </div>
      </div>
    </div>
  );
}
